'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdr';
var iconName = 'bookmark';
var width = 384;
var height = 512;
var aliases = [128278,61591];
var unicode = 'f02e';
var svgPathData = ['M48 48l0 380.4 119.8-69.9L192 344.4l24.2 14.1L336 428.4 336 48 48 48z', 'M192 344.4l24.2 14.1L336 428.4 336 48 48 48l0 380.4 119.8-69.9L192 344.4zM48 484L0 512l0-55.6L0 48 0 0 48 0 336 0l48 0 0 48 0 408.4 0 55.6-48-28L192 400 48 484z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBookmark = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;